import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';

import { Observable, BehaviorSubject } from 'rxjs';

import { ConstantsService } from '../../core/upgraded-providers';
import { default as RESOURCES } from '../resource';

interface TableRow {
    _id: string;
}

class TableDataSource implements DataSource<TableRow> {
    private _dataSubject = new BehaviorSubject<TableRow[]>([]);

    constructor() {
    }

    connect(collectionViewer: CollectionViewer): Observable<TableRow[]> {
        return this._dataSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._dataSubject.complete();
    }

    next(data) {
        this._dataSubject.next(data);
    }
}

@Component({
    selector: 'app-market-table-my-orders',
    templateUrl: './table-my-orders.component.pug',
    styleUrls: ['./table-my-orders.component.less']
})
export class TableMyOrdersComponent implements OnInit, OnChanges {
    @Input() shard: string;
    @Input() data: TableRow[] = [];

    private _columnsSbj = new BehaviorSubject<string[]>([
        'resource', '_id', 'type', 'active', 'price', 'available', 'remaining', 'total', 'room', 'expiresIn'
    ]);

    public dataSource: TableDataSource;
    public columns$ = this._columnsSbj.asObservable();

    public RESOURCES = RESOURCES;

    constructor(
        private _constants: ConstantsService
    ) {
        this.dataSource = new TableDataSource;
    }

    ngOnInit() {
    }

    ngOnChanges(changes) {
        if ('data' in changes) {
            const data = changes.data.currentValue.map((order) => {
                if (order.createdTimestamp) {
                    order.createdTimestamp += (this._constants.MARKET_ORDER_LIFE_TIME || 0);
                }

                return order;
            });

            this.dataSource.next(data);
        }
    }
}
